import { burstCacheUrl } from '@packages/http/burstCacheUrl';

interface GetImageOptions {
    isThumbnail: boolean;
    burstCache?: boolean;
}

export const getImage = (src: any, options?: GetImageOptions): null | string => {
    if (!src) {
        return null;
    }

    const src$ = (() => {
        if (typeof src === 'object') {
            if (options?.isThumbnail && src.thumbnail_path) {
                return src.thumbnail_path;
            }

            return src.file_path;
        }

        return src;
    })();

    return options?.burstCache && !`${src$}`.startsWith('blob') ? burstCacheUrl(src$) : src$;
};
